mutation SendSmsEdition($input: EditionSendToFilteredListInput!) {
    editionSendToFilteredList(input: $input) {
        edition {
            ... on SmsEdition {
                id
            }
        }
    }
}
